import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-tag-cloud',
    imports: [],
    templateUrl: './tag-cloud.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './tag-cloud.component.scss'
})
export class TagCloudComponent {
  @Input() keywords: string[] = []
}
